import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PageContentModel } from 'src/app/models/page-content.model';

@Component({
    selector: 'app-grey-text-tile',
    templateUrl: './grey-text-tile.component.html',
    styleUrls: ['./grey-text-tile.component.scss'],
    standalone: false
})
export class GreyTextTileComponent implements OnInit {

  @Input() pageContent: PageContentModel

  title: string
  content: string

  private currentLang: string

  constructor(public translateService: TranslateService) {
    this.currentLang = translateService.currentLang

    translateService.onLangChange.subscribe(lang => {
      this.setTextByLanguage(lang.lang)
    })}

  ngOnInit(): void {
    this.setTextByLanguage(this.currentLang)
  }

  setTextByLanguage(lang: string){
    if (lang == 'en'){
      this.title = this.pageContent.Title
      this.content = this.pageContent.Content
    } else {
      this.title = this.pageContent.TitleFr
      this.content = this.pageContent.ContentFr
    }
  }

}
